function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#3F3D56;}\n\t.st1{fill:#2F2E41;}\n\t.st2{fill:#FBBEBE;}\n\t.st3{fill:#575A89;}\n\t.st4{opacity:0.4;enable-background:new    ;}\n\t.st5{fill:#00A08F;}\n\t.st6{fill:#F2F2F2;}\n\t.st7{fill:#E6E6E6;}\n\t.st8{fill:#FFFFFF;}\n");

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 959,
  y: 388.5,
  className: "st0",
  width: 9.8,
  height: 388.3
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M1059.6,438c0.6,135.8-94.9,246.3-94.9,246.3s-96.6-109.6-97.2-245.4s94.9-246.3,94.9-246.3 S1059,302.2,1059.6,438z"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 767.2,
  y: 571.2,
  className: "st0",
  width: 5.1,
  height: 199.7
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M819,596.6c0.3,69.8-48.8,126.7-48.8,126.7s-49.7-56.4-50-126.2S769,470.4,769,470.4S818.6,526.8,819,596.6z"
});

var _ref7 = /*#__PURE__*/React.createElement("ellipse", {
  className: "st0",
  cx: 872,
  cy: 776.5,
  rx: 137,
  ry: 21
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M883.3,287.1c-11.6-19.6-34.6-20.5-34.6-20.5s-22.4-2.9-36.7,27c-13.4,27.8-31.8,54.7-3,61.2l5.2-16.2l3.2,17.4 c4.1,0.3,8.2,0.4,12.4,0.2c30.9-1,60.4,0.3,59.4-10.8C887.9,330.7,894.4,306,883.3,287.1z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M841.5,324c0,0,15,21,6,38s21,35,21,35l22-48c0,0-26-17-19-33L841.5,324z"
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 851.5,
  cy: 307,
  r: 26
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M761.5,337.1l21.7-28c0,0,7.7-29.4,18.7-27.9s-4.4,35.2-4.4,35.2l-21.6,31L761.5,337.1z"
});

var _ref12 = /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "871.5,710 878.5,747 893.5,751 889.5,707 "
});

var _ref13 = /*#__PURE__*/React.createElement("polygon", {
  className: "st2",
  points: "1022.5,670 1049.5,707 1060.5,712 1069.5,697 1042.5,662 "
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M865.5,381l-16.7-22c0,0-32.3,6-35.3,9s8,58,8,58s2,15,11,23l9,6l74-15l2.8-32.9c2-24.3-6.2-48.2-22.8-66.1l0,0 l-12.9,1.8L865.5,381z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M817.5,370l-5-2l-23-2c0,0-8-2-6-6s4-5,0-6s-5-2-4-5s7-9,7-9l-17-14c0,0-0.9,0.7-2.4,1.9 c-8.4,6.8-35.1,31.5-15.6,56.1c23,29,50,46,72,40L817.5,370z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M839.5,450v14c0,0-9,17-6,33c3,16,4,24,4,24c0.3,13.6,2.7,27.1,7,40c7,20-16,151,13,153s45,4,54-6 s-15-182-15-182s82,171,99,164s60-23,55-32s-131-209-131-209l-4-9L839.5,450z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M887.5,740c0,0-16-1-16,4s-8,22-8,22s-6,20,10,18s26-20,26-20l-4-19L887.5,740z"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M1054.5,705c0,0-14-9-13-3s2,22,9,23s28,7,29,9s25,10,25-3s-15-23-15-23l-17-13c0,0-11-1-13,6 S1054.5,705,1054.5,705z"
});

var _ref19 = /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 851.5,
  cy: 266.7,
  r: 16.6
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M833.2,262.3c0-8.5,6.4-15.6,14.9-16.5c-0.6-0.1-1.2-0.1-1.7-0.1c-9.2,0-16.6,7.4-16.6,16.6 c0,9.2,7.4,16.6,16.6,16.6c0,0,0,0,0,0c0.6,0,1.2,0,1.7-0.1C839.6,277.9,833.2,270.8,833.2,262.3z"
});

var _ref21 = /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "878.1,285.2 855.5,273.3 824.1,278.2 817.6,306.8 833.8,306.2 838.3,295.7 838.3,306 845.7,305.7  850,289 852.7,306.8 879.2,306.3 "
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M876.8,452.3l-35,0.9c0,0-29.9,5.8-28.2-6.2s30.8-7.8,30.8-7.8l31.9-4.9L876.8,452.3z"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M904.5,339.3c3.6-0.6,7.1,1.6,8.2,5.1c6.8,21.6,28,93.8,7,103.7C895,459.8,877,459.3,877,459.3l-9.6-23.7 l8.8-8.2l9.4-60.3l4.5-25.6L904.5,339.3z"
});

var _ref24 = /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "898,379.5 894,419.5 859,434.5 898,425.5 "
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M709.2,247.5L709.2,247.5c11.3,3,21,10.1,27.4,19.9l3.3,5.1l0.2,0.2l57.4,16.8c2.2,0.6,3.5,2.9,2.9,5.1 l-4.5,16.3c-0.6,2.2-2.9,3.5-5.1,2.9c0,0,0,0,0,0l-57.4-16l0,0l-5.8,2.2c-10.6,4-22.3,4.4-33.1,1.1l0,0L709.2,247.5z"
});

var _ref26 = /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.2808 -0.9598 0.9598 0.2808 267.7696 943.3307)",
  className: "st3",
  cx: 763.3,
  cy: 293,
  rx: 3.5,
  ry: 6.6
});

var _ref27 = /*#__PURE__*/React.createElement("circle", {
  className: "st0",
  cx: 766.7,
  cy: 294.1,
  r: 2.4
});

var _ref28 = /*#__PURE__*/React.createElement("ellipse", {
  transform: "matrix(0.3084 -0.9512 0.9512 0.3084 224.3176 857.5231)",
  className: "st5",
  cx: 701.9,
  cy: 274.5,
  rx: 28.1,
  ry: 12.7
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M712.2,277.9c4.6-14.2,3.4-27.5-2.7-30.4c0.4,0,0.7,0.1,1.1,0.2c6.7,2.2,8.2,15.9,3.4,30.6s-14.1,25-20.7,22.8 c-0.2-0.1-0.5-0.2-0.7-0.3C699.1,301.8,707.7,291.9,712.2,277.9z"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M710,247.5l-130.2-101c-23-18-45.1-37.1-66.2-57.4C476.4,53.7,426,25.4,367.3,10.4 C224.8-26.2,111.8,38.7,60.4,133.9C-18,279.5-78.2,515.8,269.8,390c76.1-27.5,153.2-30.4,211.6-44.9L693,301.5L710,247.5z"
});

var _ref31 = /*#__PURE__*/React.createElement("circle", {
  className: "st6",
  cx: 319,
  cy: 70.5,
  r: 7
});

var _ref32 = /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "454.9,86.7 453.1,86.7 453.1,84.9 452.8,84.9 452.8,86.7 450.9,86.7 450.9,87.1 452.8,87.1 452.8,88.9  453.1,88.9 453.1,87.1 454.9,87.1 "
});

var _ref33 = /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "637.9,238.7 636.1,238.7 636.1,236.9 635.8,236.9 635.8,238.7 633.9,238.7 633.9,239.1 635.8,239.1  635.8,240.9 636.1,240.9 636.1,239.1 637.9,239.1 "
});

var _ref34 = /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "624.9,285.7 623.1,285.7 623.1,283.9 622.8,283.9 622.8,285.7 620.9,285.7 620.9,286.1 622.8,286.1  622.8,287.9 623.1,287.9 623.1,286.1 624.9,286.1 "
});

var _ref35 = /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "65.9,325.7 64.1,325.7 64.1,323.9 63.8,323.9 63.8,325.7 61.9,325.7 61.9,326.1 63.8,326.1 63.8,327.9  64.1,327.9 64.1,326.1 65.9,326.1 "
});

var _ref36 = /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "145.9,107.7 144.1,107.7 144.1,105.9 143.8,105.9 143.8,107.7 141.9,107.7 141.9,108.1 143.8,108.1  143.8,109.9 144.1,109.9 144.1,108.1 145.9,108.1 "
});

var _ref37 = /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "456.9,293.7 455.1,293.7 455.1,291.9 454.8,291.9 454.8,293.7 452.9,293.7 452.9,294.1 454.8,294.1  454.8,295.9 455.1,295.9 455.1,294.1 456.9,294.1 "
});

var _ref38 = /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "265.9,43.7 264.1,43.7 264.1,41.9 263.8,41.9 263.8,43.7 261.9,43.7 261.9,44.1 263.8,44.1 263.8,45.9  264.1,45.9 264.1,44.1 265.9,44.1 "
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M266.6,187.7l-2.3,0.4c0.7,4.5,1.3,9.2,1.7,13.8l2.3-0.2C267.9,196.9,267.4,192.3,266.6,187.7z"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M260.4,160.3l-2.2,0.7c1.3,4.4,2.5,8.9,3.5,13.4l2.2-0.5C263,169.4,261.8,164.8,260.4,160.3z"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M250.5,134.1l-2.1,1c1.9,4.2,3.7,8.5,5.4,12.8l2.1-0.8C254.3,142.7,252.5,138.3,250.5,134.1z"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M237.1,109.5l-1.9,1.2c2.5,3.9,4.8,7.9,7,11.9l2-1.1C242,117.5,239.6,113.5,237.1,109.5z"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M220.5,87l-1.8,1.5c3,3.5,5.9,7.2,8.6,10.9l1.8-1.4C226.4,94.2,223.5,90.5,220.5,87z"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M200.9,66.9l-1.5,1.7c3.4,3.1,6.8,6.3,10,9.6l1.6-1.6C207.8,73.3,204.4,70,200.9,66.9z"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M178.8,49.7l-1.3,1.9c3.8,2.6,7.6,5.3,11.2,8.1l1.4-1.8C186.4,55.1,182.6,52.3,178.8,49.7z"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M158.6,37.8v2.6c2.4,1.2,4.8,2.6,7.1,3.9l1.1-2C164.2,40.7,161.4,39.2,158.6,37.8z"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M266.8,216l2.3,0c0,2.3,0,4.7,0,6.9l-2.3,0C266.8,220.6,266.8,218.3,266.8,216z"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M131.6,384.7l-2.3,0.4c0.7,4.5,1.3,9.2,1.7,13.8l2.3-0.2C132.9,393.9,132.4,389.3,131.6,384.7z"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M125.4,357.3l-2.2,0.7c1.3,4.4,2.5,8.9,3.5,13.4l2.2-0.5C128,366.4,126.8,361.8,125.4,357.3z"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M115.5,331.1l-2.1,1c1.9,4.2,3.7,8.5,5.4,12.8l2.1-0.8C119.3,339.7,117.5,335.3,115.5,331.1z"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M102.1,306.5l-1.9,1.2c2.5,3.9,4.8,7.9,7,11.9l2-1.1C107,314.5,104.6,310.5,102.1,306.5z"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M85.5,284l-1.8,1.5c3,3.5,5.9,7.2,8.6,10.9l1.8-1.4C91.4,291.2,88.5,287.5,85.5,284z"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M65.9,263.9l-1.5,1.7c3.4,3.1,6.8,6.3,10,9.6l1.6-1.6C72.8,270.3,69.4,267,65.9,263.9z"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M43.8,246.7l-1.3,1.9c3.8,2.6,7.6,5.3,11.2,8.1l1.4-1.8C51.4,252.1,47.6,249.3,43.8,246.7z"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M23.6,234.8v2.6c2.4,1.2,4.8,2.6,7.1,3.9l1.2-2C29.2,237.7,26.4,236.2,23.6,234.8z"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M131.8,413l2.3,0c0,2.3,0,4.7,0,6.9l-2.3,0C131.8,417.6,131.8,415.3,131.8,413z"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M593.6,285.7l-2.3,0.4c0.7,4.5,1.3,9.2,1.7,13.8l2.3-0.2C594.9,294.9,594.4,290.3,593.6,285.7z"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M587.4,258.3l-2.2,0.7c1.3,4.4,2.5,8.9,3.5,13.4l2.2-0.5C590,267.4,588.8,262.8,587.4,258.3z"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M577.5,232.1l-2.1,1c1.9,4.2,3.7,8.5,5.3,12.8l2.2-0.8C581.3,240.7,579.5,236.3,577.5,232.1z"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M564.1,207.5l-1.9,1.2c2.5,3.9,4.8,7.9,7,11.9l2-1.1C569,215.5,566.6,211.5,564.1,207.5z"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M547.5,185l-1.8,1.5c3,3.5,5.9,7.2,8.6,10.9l1.8-1.4C553.4,192.2,550.5,188.5,547.5,185z"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M527.9,164.9l-1.5,1.7c3.4,3.1,6.8,6.3,10,9.6l1.7-1.6C534.8,171.3,531.4,168,527.9,164.9z"
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M505.8,147.7l-1.3,1.9c3.8,2.6,7.6,5.3,11.2,8.1l1.4-1.8C513.4,153.1,509.6,150.3,505.8,147.7z"
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M485.6,135.8v2.6c2.4,1.2,4.8,2.6,7.1,3.9l1.2-2C491.2,138.7,488.4,137.2,485.6,135.8z"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M593.8,314l2.3,0c0,2.3,0,4.7,0,6.9l-2.3,0C593.8,318.6,593.8,316.3,593.8,314z"
});

var _ref66 = /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "149.3,199.9 147.6,199.9 147.6,198.2 147.3,198.2 147.3,199.9 145.6,199.9 145.6,200.2 147.3,200.2  147.3,201.9 147.6,201.9 147.6,200.2 149.3,200.2 "
});

var _ref67 = /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "129.8,302.3 128.1,302.3 128.1,300.6 127.7,300.6 127.7,302.3 126,302.3 126,302.6 127.7,302.6  127.7,304.3 128.1,304.3 128.1,302.6 129.8,302.6 "
});

var _ref68 = /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "72.4,392 70.7,392 70.7,390.3 70.4,390.3 70.4,392 68.7,392 68.7,392.3 70.4,392.3 70.4,394 70.7,394  70.7,392.3 72.4,392.3 "
});

var _ref69 = /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M231.9,278.2c-37.9-56.3-22.9-132.6,33.3-170.4s132.6-22.9,170.4,33.3s22.9,132.6-33.3,170.4 c-33.5,22.5-75.9,27.2-113.5,12.4c-5.9,21.1-27.8,33.5-49,27.5c-21.1-5.9-33.5-27.8-27.5-49C215.3,292.1,222.4,283.3,231.9,278.2z"
});

var _ref70 = /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M333.1,139.4c28.2,0,47.5,15.6,47.5,38.1c0,14.9-7.2,25.2-21.1,33.3c-13.1,7.6-17.5,13.1-17.5,22.7l0,0 c0,3.3-2.7,5.9-5.9,5.9l0,0h-14.4c-3.2,0-5.8-2.5-5.9-5.7l0-0.7c-1.3-15.5,4.1-25.1,17.7-33c12.7-7.6,18-12.4,18-21.7 c0-9.3-9-16.1-20.2-16.1c-8.5,0-15.2,4.1-18.3,10.9c-2.2,4.7-6.9,7.6-12.1,7.6l0,0c-9.8,0-16.2-10.4-11.6-19 C296.5,148,311.7,139.4,333.1,139.4z M313.4,268.1c0-8.6,7.2-15.5,16.1-15.5c8.9,0,16.1,6.8,16.1,15.5s-7.2,15.5-16.1,15.5 S313.4,276.8,313.4,268.1z"
});

function SvgMeetingDoesntExist(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b7da5827-4560-4d63-9360-f6e9beb837fe",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1104.5 797.5",
    style: {
      enableBackground: "new 0 0 1104.5 797.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetingDoesntExist);
export default __webpack_public_path__ + "static/media/meeting-doesnt-exist.2fae79d2.svg";
export { ForwardRef as ReactComponent };